import {ProductsComponent} from "../components/ProductsComponent.tsx";

export const ProductsPage = () => {
    return <ProductsComponent/>
};
